// @ts-nocheck
import React from 'react'
import { Controller } from 'react-hook-form'
import * as R from 'ramda'
import { t } from 'ttag'
import { AsyncSelect } from './common/AsyncSelect/AsyncSelect'
import { Select } from './common/Select/Select'

export const Combobox = React.forwardRef(
  (
    {
      error,
      id,
      name,
      noOptionsMessage,
      customComponents,
      options,
      placeholder,
      value,
      fetchOptions = null,
      closeMenuOnSelect,
      transformData,
      onBlur,
      filterOption,
      onChange,
      isClearable,
      isCreatable,
      isDisabled,
      isMulti,
      isReadOnly,
      isRequired,
      isSearchable,
      styles,
    },
    ref,
  ) => {
    const Component = R.isNil(fetchOptions) ? Select : AsyncSelect

    return (
      <Component
        {...{
          error,
          id,
          name,
          noOptionsMessage,
          options,
          placeholder,
          value,
          fetchOptions,
          filterOption,
          closeMenuOnSelect,
          customComponents,
          transformData,
          onBlur,
          onChange,
          isClearable,
          isCreatable,
          isDisabled,
          isMulti,
          isReadOnly,
          isRequired,
          isSearchable,
          ref,
          styles,
        }}
      />
    )
  },
)

export const ControlledCombobox = ({
  control,
  error,
  id,
  name,
  noOptionsMessage,
  customComponents,
  transformData,
  options,
  closeMenuOnSelect,
  placeholder = `${t`Select`}...`,
  fetchOptions,
  filterOption,
  isClearable,
  isCreatable,
  isDisabled,
  isMulti,
  isReadOnly,
  isRequired,
  isSearchable,
}) => (
  <Controller
    render={({ field: { name, ref, value, onBlur, onChange } }) => (
      <Combobox
        {...{
          error,
          id,
          name,
          noOptionsMessage,
          customComponents,
          transformData,
          options,
          placeholder,
          ref,
          filterOption,
          value,
          fetchOptions,
          closeMenuOnSelect,
          onBlur,
          onChange,
          isClearable,
          isCreatable,
          isDisabled,
          isMulti,
          isReadOnly,
          isRequired,
          isSearchable,
        }}
      />
    )}
    {...{ control, name }}
  />
)
